export const B2B_CHECKOUT_PAGE_KEY = 'b2b-checkout';
export const MAX_LICENSES = 40;
